import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

const sentryCreateBrowserRouter =
    Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

/**
 * @type {import('react-router').Router} Router
 */
let router;

/**
 *
 * @param {import('react-router').RouteObject[]} routes
 * @param {(router: import('react-router').Router) => void} onInitialize
 * @returns
 */
export const getOrCreateRouter = (routes = [], onInitialize = undefined) => {
    if (!router) {
        // Handle an edge case where a URL constructor fails to process when the path is "//"
        if (window.location.pathname === '//') {
            window.location.pathname = '';
            return null;
        }

        router = sentryCreateBrowserRouter(routes);
        if (onInitialize) {
            onInitialize(router);
        }
    }
    return router;
};

export const AppRouterProvider = () => <RouterProvider router={router} />;

/**
 * @param {import('react-router').To} to
 */
export const push = (to, state) => getOrCreateRouter().navigate(to, { state });

/**
 * @param {import('react-router').To} to
 */
export const replace = (to, state) =>
    getOrCreateRouter().navigate(to, { replace: true, state });

export const getRouterState = () => getOrCreateRouter().state;
